<template>
  <v-dialog persistent v-model="showDialog" max-width="700px">
    <v-card flat>
      <v-icon class="close" @click="closeModal">$sl-close</v-icon>
      <h2>{{ item.name}}</h2>
      <!-- <div class="title-icon">
        <v-icon small @click="closeModal" class="close">$sl-close</v-icon>
      </div>-->
      <p>{{ item.description }}</p>
      <h6>{{$t('ebook.education-profModalText4')}}</h6>
      <ul>
        <li>
          <p>{{ apprenticeName != '' ? apprenticeName : $t('company.you') }} {{$t('ebook.education-elementModalText1-2', { msg1: (item.numSubElementsRequired-item.numSubElementsRequiredFinished), msg2: item.numSubElementsRequired}) }}</p>
        </li>
        <li v-for="(el, index) in requiredSubElements" :key="index">
          <!-- <p>{{ $t('ebook.education-paneltext2-apprentice', {msg1: index + " ", msg2: item + " "})}}</p> -->
          <p>
            {{ apprenticeName != '' ? apprenticeName : $t('company.you') }} {{$t('ebook.education-elementModalText2-2')}}
            <i>{{el.name}}.</i>
          </p>
        </li>
      </ul>
      <h6>{{$t('ebook.education-elementModalText3')}}</h6>
      <p>{{$t('ebook.education-elementModalText4-2', {name: apprenticeName != '' ? apprenticeName : $t('company.you')})}}</p>

      <div
        class="d-flex justify-space-between"
        v-for="(sub, index) in item.bookSubElements"
        :key="index"
      >
        <p>
          <b>{{sub.name}}</b>
        </p>

        <v-icon v-if="sub.isRequired==true" class="darkgrey">{{ getIcon(sub.requiredLevel) }}</v-icon>
        <p v-else class="pr-2">*</p>
      </div>
      <div
        class="asterisk"
        v-if="showAsterisk"
      >{{$t('ebook.education-elementModalText5')}}</div>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import KnowledgeBoxes from '@/components/Common/Ebook/KnowledgeBoxes'
import API from '@/services/api.js'
import filter from 'lodash/filter'
import find from 'lodash/find'

// @group Common
// Styled EbookProfessionInfoModal component
export default {
  name: 'EbookProfessionInfoModal',

  props: {
    //is it showed
    show: {
      // `'false'` / `'true'`
       type: Boolean,
      // The default value is: `false`
      default: false
      
    },
     //has element
    element: {
       // `'Object'` 
      type: Object
    },
    apprenticeName: {      
      type: String,      
      default: ''
    },
  },
  data: () => ({
    item: {bookSubElements: []},
    showDialog: false
  }),

  components: {
    KnowledgeBoxes
  },

  created() {
    this.init()
  },

  watch: {
    show(val) {
      this.showDialog = val
      this.init
    },
    element() {
      this.init()
    }
  },

  computed: {
    ...mapGetters('currentuser', ['currentUser', 'isApprentice', 'isInstructor']),
    requiredSubElements() {
      var result = []      
      if (this.item && this.item.bookSubElements && this.item.bookSubElements.length > 0) {
        result = this.item.bookSubElements.filter(x => this.isApproved(x) === false)
      }
      return result
    },
    showAsterisk(){
      var result = []      
      if (this.item && this.item.bookSubElements && this.item.bookSubElements.length > 0) {
        result = this.item.bookSubElements.find(x => x.isRequired == false)
      }
      return result
      
    }
  },

  filters: {},
  methods: {
    init() {      
      this.item = this.element
      this.item.subElement = {
        level1Text: this.element.level1Text,
        level2Text: this.element.level2Text,
        level3Text: this.element.level3Text,
        level4Text: this.element.level4Text
      }
    },
    getIcon(level) {
      switch (level) {
        case 1:
          return '$sl-ebook-lvl1'
          break
        case 2:
          return '$sl-ebook-lvl2'
          break
        case 3:
          return '$sl-ebook-lvl3'
          break
        case 4:
          return '$sl-ebook-lvl4'
          break
        default:
          return ''
      }
    },
    isApproved(val) {      
      if (val) {
        //dont show if it isn't reguired
        if (val.isRequired == false) return true

        if (val.maxInstructorSkillEstimatedLevel && val.requiredLevel) {
          if (val.maxInstructorSkillEstimatedLevel >= val.requiredLevel) return true
        }
      }
      return false
    },
    knowledgeClick() {},
    closeModal() {
      
       // Fire close
      // @arg The argument is a object representing report
      this.$emit('close')
      this.showDialog = false
    }
  }
}
</script>

<style lang="scss">

</style>
